module.exports = __webpack_public_path__ + "d8fd54d7cfba8a59e914be244f7ca998.png";